module.exports = __webpack_public_path__ + "img/mobile-option.d34b592e.png";